import { Heading } from "@aprendaagora/simple-react-component-library";
import React from "react";

const OrganismsPage = () => {
  return (
    <div>
      <Heading text="Organisms" tailwind="mb-3" />

      <p className="p-3 border">
        Organisms are relatively complex UI components composed of groups of
        molecules and/or atoms and/or other organisms. These organisms form
        distinct sections of an interface.
      </p>
    </div>
  );
};

export default OrganismsPage;
